export const productivityEducation = {
  // Navegación principal
  title: 'Educación para la Productividad',
  description: 'Domina técnicas de productividad y aprende a usar la app de manera efectiva',
  dashboard: 'Panel',
  guidesNav: 'Guías',
  coursesNav: 'Cursos',
  exercisesNav: 'Ejercicios',
  challengesNav: 'Desafíos',
  leaderboard: 'Clasificación',
  myProgress: 'Mi Progreso',

  // Estadísticas y métricas
  level: 'Nivel',
  points: 'puntos',
  coursesCompleted: 'Cursos Completados',
  started: 'iniciados',
  lessonsCompleted: 'Lecciones Completadas',
  keepLearning: '¡Sigue aprendiendo!',
  learningStreak: 'Racha de Aprendizaje',
  days: 'días',
  minutes: 'minutos',
  min: 'min',
  lessons: 'lecciones',

  // Tarjetas de acceso rápido
  guidesDesc: 'Tutoriales paso a paso para aprendizaje rápido',
  coursesDesc: 'Cursos estructurados sobre técnicas de productividad',
  exercisesDesc: 'Practica lo que aprendes con ejercicios prácticos',
  challengesDesc: 'Pon a prueba tus habilidades con desafíos diarios y semanales',
  leaderboardDesc: 'Compara tu progreso con otros estudiantes',
  progressDesc: 'Rastrea tu viaje de aprendizaje y logros',

  // Acciones
  explore: 'Explorar',
  startLearning: 'Comenzar a Aprender',
  practice: 'Practicar',
  viewChallenges: 'Ver Desafíos',
  viewRankings: 'Ver Clasificación',
  viewProgress: 'Ver Progreso',
  startCourse: 'Iniciar Curso',
  start: 'Iniciar',
  review: 'Repasar',
  backToCourses: 'Volver a Cursos',
  backToCourse: 'Volver al Curso',
  markComplete: 'Marcar como Completado',

  // Categorías
  categories: {
    all: 'Todos los Cursos',
    fundamentals: 'Fundamentos',
    'time-management': 'Gestión del Tiempo',
    goals: 'Metas',
    habits: 'Hábitos',
    tasks: 'Tareas',
    focus: 'Enfoque y Trabajo Profundo',
    tools: 'Herramientas Avanzadas',
  },

  // Niveles de dificultad
  beginner: 'Principiante',
  intermediate: 'Intermedio',
  advanced: 'Avanzado',

  // Detalles del curso
  productivityCourses: 'Cursos de Productividad',
  yourProgress: 'Tu Progreso',
  progress: 'Progreso',
  completed: 'Completado',
  notStarted: 'No iniciado',
  courseLessons: 'Lecciones del Curso',
  videoPlayer: 'Reproductor de Video',

  // Mensajes
  recentActivity: 'Actividad Reciente',
  recentActivityDesc: 'Tu viaje de aprendizaje',
  noActivityYet: '¡Aún no hay actividad. Comienza a aprender para rastrear tu progreso!',
  courseNotFound: 'Curso no encontrado',
  lessonNotFound: 'Lección no encontrada',
  invalidLesson: 'Lección inválida',
  noLessonsYet: 'Aún no hay lecciones disponibles para este curso',
  noCoursesInCategory: 'No hay cursos disponibles en esta categoría',
  
  // Quick access and page headers
  quickGuides: 'Guías Rápidas',
  quickGuidesDesc: 'Tutoriales paso a paso para aprender rápido',
  practicalExercises: 'Ejercicios Prácticos',
  practicalExercisesDesc: 'Practica lo que aprendes con ejercicios hands-on',
  productivityChallenges: 'Desafíos de Productividad',
  challengesDetailDesc: 'Pon a prueba tus habilidades con desafíos',
  globalLeaderboard: 'Clasificación Global',
  leaderboardDetailDesc: 'Compara tu progreso con otros estudiantes',
  myLearningProgress: 'Mi Progreso de Aprendizaje',
  progressDetailDesc: 'Rastrea tu viaje de aprendizaje y logros',
  
  // Additional keys
  steps: 'pasos',
  courses: 'cursos',
  startGuide: 'Iniciar Guía',
  startExercise: 'Iniciar Ejercicio',
  continue: 'Continuar',
  joinChallenge: 'Unirse al Desafío',
  allChallenges: 'Todos los Desafíos',
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual',
  allTime: 'Todo el Tiempo',
  thisMonth: 'Este Mes',
  thisWeek: 'Esta Semana',
  topLearners: 'Mejores Estudiantes',
  topLearnersDesc: 'Los estudiantes con más puntos de todos los tiempos',
  thisMonthLeaders: 'Líderes del Mes',
  thisMonthLeadersDesc: 'Los mejores estudiantes de este mes',
  thisWeekLeaders: 'Líderes de la Semana',
  thisWeekLeadersDesc: 'Los mejores estudiantes de esta semana',
  anonymousUser: 'Usuario Anónimo',
  currentLevel: 'Nivel Actual',
  progressToNext: 'Progreso al siguiente',
  pointsUntilNext: 'puntos hasta el siguiente nivel',
  keepGoing: '¡Sigue así!',
  streakMotivation: 'Sigue aprendiendo cada día para mantener tu racha',
  courseProgress: 'Progreso de Cursos',
  courseProgressDesc: 'Tu avance en los cursos',
  learningStats: 'Estadísticas de Aprendizaje',
  totalTimeInvested: 'Tiempo Total Invertido',
  totalPoints: 'Puntos Totales',
  availableExercises: 'Ejercicios Disponibles',
  badgesAndAchievements: 'Insignias y Logros',
  
  // Guides
  guides: {
    pomodoroGuide: 'Cómo Usar el Temporizador Pomodoro',
    pomodoroGuideDesc: 'Aprende a usar la técnica Pomodoro para mejorar tu enfoque',
    goalSettingGuide: 'Estableciendo Tu Primera Meta SMART',
    goalSettingGuideDesc: 'Aprende a crear metas efectivas y alcanzables',
    habitTrackingGuide: 'Rastreando Hábitos de Manera Efectiva',
    habitTrackingGuideDesc: 'Domina el sistema de seguimiento de hábitos',
    timeBlockingGuide: 'Bloques de Tiempo para Productividad',
    timeBlockingGuideDesc: 'Organiza tu día con bloques de tiempo efectivos',
    taskPrioritizationGuide: 'Priorización de Tareas con Matrices',
    taskPrioritizationGuideDesc: 'Aprende a priorizar tareas usando matrices de decisión',
    analyticsGuide: 'Usando Analytics para Optimizar',
    analyticsGuideDesc: 'Interpreta tus métricas para mejorar continuamente',
  },
  
  // Exercises
  exercises: {
    timeAudit: 'Auditoría de Tiempo Personal',
    timeAuditDesc: 'Registra cómo usas tu tiempo durante 3 días',
    pomodoroChallenge: 'Desafío Pomodoro de 4 Sesiones',
    pomodoroChallengeDesc: 'Completa 4 sesiones Pomodoro en un día',
    goalBreakdown: 'Desglose de Meta en Milestones',
    goalBreakdownDesc: 'Desglosa una meta grande en pasos accionables',
    habitStacking: 'Stack de Hábitos Matutino',
    habitStackingDesc: 'Construye una rutina de 3 hábitos consecutivos',
    deepWorkSession: 'Sesión de Trabajo Profundo',
    deepWorkSessionDesc: 'Completa 2 horas de trabajo profundo sin distracciones',
    weeklyReview: 'Revisión Semanal Completa',
    weeklyReviewDesc: 'Realiza una revisión exhaustiva de tu semana',
  },
  
  // Challenges
  challenges: {
    dailyPomodoro: 'Maestro Pomodoro Diario',
    dailyPomodoroDesc: 'Completa 4 sesiones Pomodoro hoy',
    morningRoutine: 'Rutina Matutina Perfecta',
    morningRoutineDesc: 'Completa tu rutina matutina antes de las 9 AM',
    weeklyGoals: 'Revisión Semanal de Metas',
    weeklyGoalsDesc: 'Revisa y actualiza tus metas cada día esta semana',
    taskMaster: 'Maestro de Tareas',
    taskMasterDesc: 'Completa 50 tareas esta semana',
    deepWorkMonth: 'Mes de Trabajo Profundo',
    deepWorkMonthDesc: 'Acumula 20 horas de trabajo profundo este mes',
    productivityMaster: 'Maestro de Productividad',
    productivityMasterDesc: 'Completa 30 días de actividad consistente',
  },
};
